import { authorizedSyliusFetch, GetActiveCartResponse, UpdateActiveCartResponse } from '../../../entities/@api/Sylius';
import { cartToken } from '../../../entities/@shop/Cart/Cart';
import { isFetchResultSuccessful } from '../../../entities/FetchResult/FetchResult';
import { fetchCart } from '../../@shop/cart/cartActions';
import { ReduxFetchAction } from '../../defaults';
import {
    setActiveCartToken,
    setError,
    setHasFetched,
    setIsLoading,
} from './activeCartSlice';

export const fetchActiveCart: ReduxFetchAction<string> = customerId => async dispatch => {
    dispatch(setIsLoading(true));
    dispatch(setHasFetched(false));
    dispatch(setError(''));
    dispatch(setActiveCartToken(''));

    try {
        const activeCartResponse = await authorizedSyliusFetch<GetActiveCartResponse>(`/shop/customers/${customerId}/active-cart`, {
            headers: {
                Accept: 'application/json',
            },
        });

        if (!isFetchResultSuccessful(activeCartResponse)) {
            dispatch(setError(activeCartResponse.error));
            return;
        }

        const { isUsableAsCart, orderToken } = activeCartResponse.data;

        if (isUsableAsCart && orderToken) {
            dispatch(setActiveCartToken(orderToken));

            localStorage.setItem(cartToken, JSON.stringify(orderToken));
        }

        dispatch(fetchCart());
    } catch (error) {
        console.error('[fetchActiveCart]', error);
    } finally {
        dispatch(setIsLoading(false));
        dispatch(setHasFetched(true));
    }
};

export const storeActiveCart: ReduxFetchAction<string> = (customerId, orderToken) => async dispatch => {
    dispatch(setIsLoading(true));
    dispatch(setError(''));

    try {
        const activeCartResponse = await authorizedSyliusFetch<UpdateActiveCartResponse>(`/shop/customers/${customerId}/active-cart`, {
            method: 'PUT',
            body: JSON.stringify({ orderToken }),
        });

        if (!isFetchResultSuccessful(activeCartResponse)) {
            dispatch(setError(activeCartResponse.error));
        }
    } catch (error) {
        console.error('[storeActiveCart]', error);
    } finally {
        dispatch(setIsLoading(false));
    }
};
